import React from 'react';
import { VictoryLine } from 'victory';
import { ChartDataPoint } from '../../axisUtils';

type LineProps = {
  data: ChartDataPoint[];
  stroke: string;
};

const Line = ({ data, stroke }: LineProps) => <VictoryLine
  {...{ data }}
  style={{ data: { stroke, strokeWidth: 2 } }}
  x='index'
  y='value'
/>;

export default Line;
